// inv/src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import languages from './locales/languages.js';

let resources;

const isServer = typeof window === 'undefined';

if (isServer) {
  // Dynamically import the server loader (to keep it out of the client bundle)
  const { loadResources } = await import('./locales/loadTranslations.js');
  resources = loadResources();
} else {
  // On the client, use a regular import
  resources = (await import('./locales/index.js')).default;
}

// mapping code → path prefix
const languagePrefixes = languages.reduce((acc, lang) => {
  acc[lang.code] = lang.code !== 'en' ? `/${lang.code}` : '';
  return acc;
}, {});

const getCurrentLanguage = () => {
  if (isServer) return 'en'; // default on the server
  const pathSegments = window.location.pathname.split('/');
  const languageSegment = pathSegments[1] || 'en';
  return Object.keys(languagePrefixes).includes(languageSegment) ? languageSegment : 'en';
};

const initialLanguage = getCurrentLanguage();

if (!isServer) {
  try {
    localStorage.setItem('i18nextLng', initialLanguage);
  } catch (e) {
    // ignore
  }
}

i18n
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    lng: initialLanguage,
    debug: process.env.NODE_ENV === 'development',
    interpolation: {
      escapeValue: false,
    },
    resources,
    postProcess: ['phraseapp'],
  });

export { i18n, languagePrefixes };
export default i18n;
